import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgOnTrac({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.121 16.498c0 .51-.18.724-.51.724-.329 0-.51-.213-.51-.724v-1.63c0-.51.181-.724.51-.724.33 0 .51.214.51.724v.116h.922c-.016-.947-.395-1.597-1.432-1.597-1.053 0-1.432.675-1.432 1.646v1.3c0 .972.379 1.646 1.432 1.646 1.054 0 1.432-.674 1.432-1.645v-.116h-.922v.28zM15.451 13.387c.856 0 1.341.396 1.341 1.202v2.839a2.764 2.764 0 00.058.47h-.88c-.005-.067-.016-.132-.027-.193-.01-.053-.019-.104-.023-.153-.345.28-.633.427-1.078.427-.625 0-.938-.427-.938-.995 0-.972.642-1.507 1.967-2.009v-.263c0-.37-.148-.568-.453-.568-.42 0-.51.247-.526.626h-.922c.05-.897.617-1.383 1.481-1.383zm-.197 3.835c.254 0 .46-.19.617-.412v-1.16c-.839.478-1.045.783-1.045 1.17 0 .287.148.402.428.402zM13.361 14.26c.272 0 .428.049.593.09v-.963h-.19c-.436 0-.823.223-1.045.601h-.016v-.518h-.88v4.427h.92v-3.045c0-.394.306-.592.618-.592"
        fill="#1D2953"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.06 17.897h1.02v-5.053h.988v-.889H9.073v.889h.987v5.053z"
        fill="#1D2953"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 13.387c-.535 0-.733.198-1.12.527v-.444h-.872v4.427h.922v-3.473c.214-.156.395-.28.593-.28.197 0 .328.1.328.321v3.432h.922v-3.58c0-.576-.288-.93-.773-.93M2.686 13.395c0-.839.494-1.522 1.564-1.522s1.564.683 1.564 1.522v3.062c0 .84-.494 1.522-1.564 1.522s-1.564-.683-1.564-1.522v-3.062zM4.25 17.09c.411 0 .543-.213.543-.657V13.42c0-.444-.132-.659-.543-.659-.411 0-.543.215-.543.66v3.012c0 .444.132.657.543.657zM2.552 11.3c.752-.553 3.242-2.465 6.925-.924v-1.87C5.505 7.824 3.41 9.715 2.552 11.3z"
        fill="#FBCB07"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.155 8.075c-.365.25-.771.613-.986.893 2.586-1.619 5.532-.836 5.556-.829l5.553-1.718S9.36 5.206 5.155 8.075z"
        fill="#FBCB07"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.917 6.922l-5.78 1.782v1.703l4.7 2.025 5.753-2.134v-1.81l-4.673-1.566z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.812 8.406v1.91c0 .095-.059.18-.148.214l-5.696 2.16a.276.276 0 01-.198-.006l-4.782-2.011a.227.227 0 01-.14-.21V8.65a.241.241 0 01.16-.209l5.793-1.791a.23.23 0 01.137 0l4.72 1.543c.156.069.154.21.154.212zm-6.179 2.32l-4.33-1.73v1.314l4.33 1.813v-1.398zm.23-.4L10.76 8.688l5.106-1.58 4.03 1.317-5.032 1.901zm.227 1.83l5.265-1.998V8.74l-5.265 1.99v1.427z"
        fill="#FBCB07"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.896 8.806l1.056-.354c.045-.015.065-.059.046-.097-.018-.037-.07-.057-.114-.042l-1.056.355c-.044.014-.065.057-.046.096.019.037.07.056.114.042M12.15 8.906c.02.038.07.057.113.042l1.057-.355c.044-.014.065-.057.046-.095-.019-.039-.07-.057-.114-.043l-1.057.355c-.044.015-.064.058-.045.096M14.366 8.796l1.442-.523c.06-.021.087-.08.062-.131-.026-.052-.094-.077-.154-.055l-1.445.52c-.061.022-.09.082-.063.134.026.053.097.077.158.055zM14.656 8.932c.026.051.095.076.156.054l1.43-.522c.06-.022.087-.081.062-.133-.025-.05-.093-.074-.152-.053l-1.434.52c-.06.022-.088.082-.062.134zM15.16 9.113c.026.052.095.075.155.053l1.418-.522c.058-.021.085-.08.06-.131-.025-.05-.093-.075-.15-.054l-1.42.521c-.06.022-.09.082-.063.133zM21.196 13.354a.498.498 0 00-.5-.5.504.504 0 00-.5.5c0 .133.052.256.147.351a.495.495 0 00.709-.001.48.48 0 00.144-.35zm-.5-.452a.449.449 0 01.451.452.433.433 0 01-.13.315.447.447 0 01-.639.002.446.446 0 01.002-.638.436.436 0 01.315-.13zm.253.314c0 .08-.053.14-.139.15l.131.269h-.09l-.125-.258h-.145v.258h-.08v-.578h.21c.16 0 .238.047.238.16zm-.369.108v-.214h.115c.117 0 .174.03.174.103 0 .089-.052.111-.174.111h-.114z"
        fill="#1D2953"
      />
    </svg>
  )
}

export default SvgOnTrac
